<template>
    <div class="content">
        <h2>
            EMERGENCY CARE
        </h2>
        <h4>
            Services for a medical condition manifesting itself by acute symptoms of
            sufficient severity (including severe pain) such that the absence of
            immediate medical attention could reasonably be expected to result in the
            following:
        </h4>
        <ul>
            <li>a.) Placing the patient’s life/health in serious jeopardy</li>
            <li>b.) Serious impairment of bodily functions</li>
            <li>c.) Serious dysfunctions of any bodily organ or part</li>
        </ul>
    </div>
</template>

<script>
export default {}
</script>

<style scoped>
.content {
  margin: auto;
  padding: 10px;
}
.content h2 {
  font-size: 16px;
  text-align: justify;
  color: #1b5e20;
}
.content h4 {
  font-weight: normal;
  font-size: 13px;
  text-align: justify;
  padding-left: 10px;
}
.content ul li {
  font-size: 13px;
  color: black;
  margin-top: 10px;
  list-style: none;
  text-align: justify;
}
@media (max-width: 599px) {
  .content {
    width: 90%;
    margin-top: 10px;
  }
}

@media (min-width: 599px) and (max-width: 968px) {
  .content {
   
    width: 80%;
  }
}

@media (min-width: 968px) and (max-width: 1264px) {
  .content {
    width: 100%;
  }
}
@media (min-width: 1264px) and (max-width: 1904px) {
  .content {
    width: 100%;
  }
}
</style>
